<div class="container-fluid py-3">
  <h5 class="mb-3">Admin Dashboard</h5>
  <app-toola-sync-status></app-toola-sync-status>
</div>
